import React from 'react'
import Image1 from './T-Images/Image11.webp'
import Image2 from './T-Images/Image12.webp'
import Image3 from './T-Images/Image13.webp'
import Image4 from './T-Images/Image2.webp'
import Image5 from './T-Images/Image5.webp'
import Image6 from './T-Images/Image7.webp'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


export const Trending = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 2,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    };
  return (
    <div>
            <div className="content">
                <h1>Trending Bags</h1>
                <div className="line"></div>
            </div>

            <div className="product">
                <Slider {...settings}>
                    <div>
                        <div className="card">
                            <img src={Image1} alt="" />
                            <h2>Tourister</h2>
                            <div className="price">
                            <span>$169</span><p>$199</p>
                            </div>
                            
                            
                            <div className="btn-cart"></div>
                        </div>
                    </div>
                    <div>
                        <div className="card">
                            <img src={Image2} alt="" />
                            <h2>Tourister</h2>
                            <div className="price">
                            <span>$169</span><p>$199</p>
                            </div>
                            <div className="btn-cart"></div>
                        </div>
                    </div>
                    <div>
                        <div className="card">
                            <img src={Image3} alt="" />
                            <h2>Tourister</h2>
                            <div className="price">
                            <span>$169</span><p>$199</p>
                            </div>
                            <div className="btn-cart"></div>
                        </div>
                    </div>
                    <div>
                        <div className="card">
                            <img src={Image4} alt="" />
                            <h2>Tourister</h2>
                            <div className="price">
                            <span>$169</span><p>$199</p>
                            </div>
                            <div className="btn-cart"></div>
                        </div>
                    </div>
                    <div>
                        <div className="card">
                            <img src={Image5} alt="" />
                            <h2>Tourister</h2>
                            <div className="price">
                            <span>$169</span><p>$199</p>
                            </div>
                            <div className="btn-cart"></div>
                        </div>
                    </div>
                    <div>
                        <div className="card">
                            <img src={Image6} alt="" />
                            <h2>Tourister</h2>
                            <div className="price">
                            <span>$169</span><p>$199</p>
                            </div>
                            <div className="btn-cart"></div>
                        </div>
                    </div>
                    <div>
                        <div className="card">
                            <img src={Image4} alt="" />
                            <h2>Tourister</h2>
                            <div className="price">
                            <span>$169</span><p>$199</p>
                            </div>
                            <div className="btn-cart"></div>
                        </div>
                    </div>
                    <div>
                        <div className="card">
                            <img src={Image3} alt="" />
                            <h2>Tourister</h2>
                            <div className="price">
                            <span>$169</span><p>$199</p>
                            </div>
                            <div className="btn-cart"></div>
                        </div>
                    </div>
                </Slider>
            </div>



    </div>
  )
}
